import { useState as c, useLayoutEffect as o } from "react";
const i = (e) => {
  const [a, s] = c(
    () => typeof window < "u" && window.matchMedia(e).matches
  );
  return o(() => {
    const t = window.matchMedia(e), n = () => s(t.matches);
    return t.addEventListener("change", n), () => t.removeEventListener("change", n);
  }, [e]), a;
};
export {
  i as u
};
//# sourceMappingURL=media-query.B9bznea_.js.map
